import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { custom } from 'devextreme/ui/dialog';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { InvoiceDraftListComponent } from '../../finance/invoice-draft-list/invoice-draft-list.component';
import { FormComponent } from '../../shared/form/form.component';
import { ChangeInvoiceComponent } from '../change-invoice/change-invoice.component';

@Component({
  selector: 'app-basket',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./basket.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class BasketComponent extends InvoiceDraftListComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
    public route: ActivatedRoute,
    public router: Router
  ) {
    super(cookieService, activeModal, titleService, translator, service, route, router);
    this.subentity = 'basket';
  }

  payable: number;

  getBody() {
    const body = super.getBody();
    body.mode = 'user';
    const query = ['account_id', '=', this.selectedAccount || this.username];
    if (body.query) {
      body.query = [body.query, 'and', query];
    } else {
      body.query = query;
    }
    return body;
  }

  async handleResult(result) {
    this.service.apiCall('api/transaction/read', {
      query: ['account_id', '=', this.selectedAccount || this.username],
      fields: ['balance'],
      orderby: 'id',
      desc: true,
      limit: 1,
      skip: 0,
      raw: true
    }).subscribe(balanceResult => {
      this.payable = balanceResult[0] ? -1 * balanceResult[0].balance : 0;
      result.forEach(element => {
        this.payable += element.payable;
      });
      if (this.payable > 0) {
        this.customActions.find(a => a.name === 'PAY_ALL').caption = `${this.translator.instant('PAY_ALL')}: ${this.formatMoney(this.payable)}`;
      } else {
        this.customActions = [];
      }
      super.handleResult(result);
    });
  }

  async perform(action, row) {
    return new Promise(async (resolve, reject) => {
      try {
        switch (action.name) {
          case 'PAY_ALL':
            const dialog = custom({
              title: this.translator.instant('PAY_ALL'), messageHtml: this.translator.instant('CONFIRM_PAY_ALL'), buttons: [{
                text: this.translator.instant('YES'), onClick: function () {
                  return true;
                }
              }, {
                text: this.translator.instant('NO'), onClick: function () {
                  return false;
                }
              }]
            });
            dialog.show().done(async (res) => {
              if (!res) {
                dialog.hide();
              } else {
                this.loadingVisible = true;
                this.service.perform(this.entity, action.name, { username: this.selectedAccount }).subscribe((result: any) => {
                  this.loadingVisible = false;
                  if (result.credit) {
                    this.handleSuccess();
                  } else if (result.gate) {
                    if (result.gate == 'ASP') {
                      const params = new URL(result.redirectUrl).searchParams;
                      const RefId = params.get('RefId');
                      const mobileap = params.get('mobileap');
                      this.postRefId(RefId, mobileap)
                    } else {
                      if (result.redirectUrl) {
                        window.location.href = result.redirectUrl;
                      } else {
                        this.handleError({ message: this.translator.instant('GATE_EMPTY_REDIRECT') });
                      }
                    }

                  } else {
                    this.handleError({ message: this.translator.instant('GATE_EMPTY') });
                  }
                }, error => {
                  this.loadingVisible = false;
                  this.handleError(error);
                });
              }
            });

            break;
          case 'SEND_LINK':
            const sendLinkForm = this.activeModal.open(FormComponent, { size: 'sm' });
            sendLinkForm.componentInstance.colCount = 1;
            sendLinkForm.componentInstance.title = action.caption;
            sendLinkForm.componentInstance.hiddenApply = true;
            sendLinkForm.componentInstance.hiddenReset = true;
            sendLinkForm.componentInstance.fields = [
              {
                name: 'mobile',
                caption: this.translator.instant('MOBILE'),
                type: {
                  name: 'number',
                  rules: []
                }
              }
            ];
            sendLinkForm.componentInstance.done.subscribe(async (res) => {
              sendLinkForm.componentInstance.loading = true;
              await super.perform(action, { id: row.id, account_id: row.account_id, mobile: res.mobile });
              this.handleSuccess();
              sendLinkForm.componentInstance.loading = false;
              sendLinkForm.close();
            });
            break;
          case 'SEND_LINK_ALL':
            const sendLinkAllForm = this.activeModal.open(FormComponent, { size: 'sm' });
            sendLinkAllForm.componentInstance.colCount = 1;
            sendLinkAllForm.componentInstance.title = action.caption;
            sendLinkAllForm.componentInstance.hiddenApply = true;
            sendLinkAllForm.componentInstance.hiddenReset = true;
            sendLinkAllForm.componentInstance.fields = [
              {
                name: 'mobile',
                caption: this.translator.instant('MOBILE'),
                type: {
                  name: 'number',
                  rules: []
                }
              }
            ];
            sendLinkAllForm.componentInstance.done.subscribe(async (res) => {
              sendLinkAllForm.componentInstance.loading = true;
              await super.perform(action, { account_id: this.selectedAccount || this.username, mobile: res.mobile });
              this.handleSuccess();
              sendLinkAllForm.componentInstance.loading = false;
              sendLinkAllForm.close();
            });
            break;
          // case 'SEND_LINK_ALL':
          //   await super.perform(action, { account_id: this.selectedAccount || this.username });
          //   this.handleSuccess();
          //   break;
          default:
            await super.perform(action, row);
            resolve(true);
        }
      } catch (error) {
        reject(error);
      }
    });
  }



}
